import { useCallback, useEffect, useState } from "react";
function useOverflowX() {
  const [node, setNode] = useState(null);
  const [overflows, setOverflows] = useState(false);
  const ref = useCallback((el) => {
    setNode(el);
  }, []);
  useEffect(() => {
    if (!node) return void 0;
    const measure = () => {
      setOverflows(node.scrollWidth > node.clientWidth + 1);
    };
    measure();
    const Observer = globalThis.ResizeObserver;
    if (!Observer) return void 0;
    const observer = new Observer(measure);
    observer.observe(node);
    for (const child of Array.from(node.children)) observer.observe(child);
    return () => {
      observer.disconnect();
    };
  }, [node]);
  return [ref, overflows];
}
export {
  useOverflowX
};
//# sourceMappingURL=use-overflow-x.js.map